<div>
    <p class="text-description-component">{{text}}</p>
    <app-info-chips imgUrl="../../../../assets/images/landing-system/empty-component.png" textChip="No disponible"></app-info-chips>
</div>
